import '../../lib/otel';
import runSentry from '../../lib/sentry';

import '../asset';
import * as React from 'react';
import { createRoot } from 'react-dom/client';

import { Provider } from 'react-redux';
import config from 'common/config';

// 全局配置
window.config = config;

// 样式
import '../common/styles/theme';
import './styles/index';

// 状态
import store from 'pc-sales/store';

// 根组件
import Root from 'pc-sales/pages/Root';

// 热更新支持
if (module?.hot) {
    module.hot.accept();
}

void runSentry();

const container = document.getElementById('app');

const root = createRoot(container);

root.render(
    <Provider store={store}>
        <Root />
    </Provider>,
);
